import * as React from "react";
const SvgFiRrViruses = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-viruses_svg__a)">
      <path
        fill="#062147"
        d="M11.899 8H13a1 1 0 1 0 0-2h-1.101a5 5 0 0 0-.73-1.756l1.247-1.247q.041.002.083.002a1.5 1.5 0 1 0-1.498-1.417L9.754 2.829a5 5 0 0 0-1.756-.73V.998a1 1 0 1 0-2 0v1.101a5 5 0 0 0-1.756.73L2.995 1.582q.002-.041.002-.083A1.499 1.499 0 1 0 0 1.5 1.5 1.5 0 0 0 1.5 3q.042 0 .083-.002L2.83 4.245a5 5 0 0 0-.73 1.756H.999a1 1 0 1 0 0 2H2.1c.13.638.382 1.231.73 1.756l-1.247 1.247q-.041-.002-.083-.002a1.5 1.5 0 1 0 1.5 1.5q0-.042-.002-.083l1.247-1.247c.525.348 1.118.6 1.756.73v1.101a1 1 0 1 0 2 0v-1.101A5.01 5.01 0 0 0 11.9 8.003zM7 10c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3m15.388 9H23a1 1 0 1 0 0-2h-.612a4.5 4.5 0 0 0-.579-1.394l.608-.608q.041.003.083.002a1.5 1.5 0 1 0-1.498-1.417l-.608.608A4.5 4.5 0 0 0 19 13.612V13a1 1 0 1 0-2 0v.612a4.5 4.5 0 0 0-1.394.579l-.608-.608q.003-.041.002-.083a1.5 1.5 0 1 0-1.5 1.5q.042 0 .083-.002l.608.608A4.5 4.5 0 0 0 13.612 17H13a1 1 0 1 0 0 2h.612c.114.502.313.972.579 1.394l-.608.608L13.5 21a1.5 1.5 0 1 0 1.5 1.5q0-.042-.002-.083l.608-.608c.423.267.893.465 1.394.58V23a1 1 0 1 0 2 0v-.612a4.5 4.5 0 0 0 1.394-.579l.608.608Q21 22.458 21 22.5a1.5 1.5 0 1 0 1.417-1.498l-.608-.608c.267-.423.465-.893.579-1.394M18 20.5a2.503 2.503 0 0 1-2.5-2.5c0-1.379 1.122-2.5 2.5-2.5s2.5 1.121 2.5 2.5-1.122 2.5-2.5 2.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-viruses_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrViruses;
